import PropTypes from "prop-types"
import React, { useState } from "react"
import {
  Row,
  Col,
  CardBody,
  Card,
  Container,
  Form,
  Input,
  FormFeedback,
  Label,
} from "reactstrap"
import { Link, useNavigate } from "react-router-dom"
import { useAuth } from "hooks/useAuth"
import withRouter from "components/Common/withRouter"
import * as Yup from "yup"
import { useFormik } from "formik"
import profile from "assets/images/profile-img.png"
import logo from "assets/images/logo.svg"

const Login = () => {
  document.title = "Login | CA Portal"

  const navigate = useNavigate()

  const { login } = useAuth()
  const [loginError, setLoginError] = useState(null)

  const validationSchema = Yup.object({
    emailOrPhone: Yup.string().required(
      "Please Enter Your Email or Mobile Number"
    ),
    password: Yup.string().required("Please Enter Your Password"),
  })

  const validation = useFormik({
    initialValues: { emailOrPhone: "", password: "" },
    validationSchema,
    onSubmit: async values => {
      try {
        setLoginError(null)

        const response = await login({
          email: values.emailOrPhone,
          password: values.password,
        })

        const userData = response?.data

        if (!userData) {
          setLoginError("Login failed. Please try again.")
          return
        }

        // Save user info
        localStorage.setItem("email", userData.email || "")
        localStorage.setItem("mobile", userData.mobile || "")

        // MFA USERS
        if (userData.mfaEnabled) {
          localStorage.setItem("tempToken", userData.token)
          navigate("/verify-otp")
          return
        }

        // NON MFA USERS → LOGIN DIRECTLY
        if (userData.token) {
          localStorage.setItem("sessionToken", userData.token)
          localStorage.setItem("refreshToken", userData.refreshToken)
          navigate("/dashboard")
          return
        }

        setLoginError("Login failed. Please try again.")
      } catch (error) {
        console.error("Error during login:", error)

        setLoginError(
          error?.response?.data?.message ||
          "Login failed. Please check your credentials and try again."
        )

        setTimeout(() => {
          setLoginError(null)
        }, 5000)
      }
    },
  })

  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-primary">
                  <Row>
                    <Col className="col-7">
                      <div className="p-4 text-white">
                        <span className="font-size-14 fw-bolder">
                          CA Admin Portal
                        </span>
                        <p>Sign in to continue.</p>
                      </div>
                    </Col>
                    <Col className="col-5 align-self-end">
                      <img src={profile} alt="" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div>
                    <Link to="/" className="logo-light-element">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={logo}
                            alt=""
                            className="rounded-circle"
                            height="34"
                          />
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="p-2">
                    <Form
                      className="form-horizontal"
                      onSubmit={e => {
                        e.preventDefault()
                        validation.handleSubmit()
                        return false
                      }}
                    >
                      <div className="avatar-md profile-user-wid">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={logo}
                            alt=""
                            className="rounded-circle"
                            height="34"
                          />
                        </span>
                      </div>
                      <div className="mb-3">
                        <Label className="form-label">
                          Email or Phone Number
                        </Label>
                        <Input
                          name="emailOrPhone"
                          className="form-control"
                          placeholder="Enter Email or Phone Number"
                          type="text"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.emailOrPhone}
                          invalid={
                            validation.touched.emailOrPhone &&
                            validation.errors.emailOrPhone
                          }
                        />
                        {validation.touched.emailOrPhone &&
                          validation.errors.emailOrPhone && (
                            <FormFeedback type="invalid">
                              {validation.errors.emailOrPhone}
                            </FormFeedback>
                          )}
                      </div>
                      <div className="mb-3">
                        <Label className="form-label">Password</Label>
                        <Input
                          name="password"
                          value={validation.values.password || ""}
                          type="password"
                          placeholder="Enter Password"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          invalid={
                            validation.touched.password &&
                              validation.errors.password
                              ? true
                              : false
                          }
                        />
                        {validation.touched.password &&
                          validation.errors.password ? (
                          <FormFeedback type="invalid">
                            {validation.errors.password}
                          </FormFeedback>
                        ) : null}
                      </div>
                      {loginError && (
                        <div className="alert alert-danger">{loginError}</div>
                      )}

                      <div className="mt-3 d-grid">
                        <button
                          className="btn btn-primary btn-block"
                          type="submit"
                        >
                          Log In
                        </button>
                      </div>
                      <div className="mt-4 text-center">
                        <Link to="/forgot-password" className="text-muted">
                          <i className="mdi mdi-lock me-1" />
                          Forgot your password?
                        </Link>
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(Login)

Login.propTypes = {
  history: PropTypes.object,
}
